import { render } from "./Spin.vue?vue&type=template&id=22d83114"
import script from "./Spin.vue?vue&type=script&lang=js"
export * from "./Spin.vue?vue&type=script&lang=js"

import exportComponent from "F:\\projects\\Cloutlayer\\Cloutlayer\\Source\\webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__